import { createApiAction } from '@saucelabs/sl-util-redux';
import { selectors as moduleSelectors } from '@saucelabs/sl-module-performance';

import * as types from './types';
import * as actions from './actions';
import * as selectors from './selectors';
import { PERFORMANCE_EVENTS, trackEvent } from './../../tracking';

import { operations } from './index';

export const fetchMetricsHistory = (options) => (dispatch, getState) => {
  const state = getState();
  return dispatch(actions.fetchMetricsHistory(
    selectors.metricHistoryFilterSelector(state, options),
  ));
};

export const changeTestPage = (options) => async (dispatch, getState) => {
  const { orderIndex } = options;
  await dispatch(
    actions.updatePerfType(selectors.getPerfTypeSelector(getState(), orderIndex)),
  );
  return Promise.all([
    dispatch(actions.updateSelectedTestPageInfo(orderIndex)),
    dispatch(operations.fetchMetricsHistory(options)),
    dispatch(actions.updateSelectedBaselineChartDataPoint(null)),
    dispatch(actions.updateSelectedTestPageInfo(orderIndex)),
  ]);
};

export const changeMetricsSelection = (options) => (dispatch) => {
  const { selectedMetrics } = options;
  const { updateSelectedMetrics, updateSelectedBaselineChartDataPoint } = actions;
  const changeMetricsSelectionActions = [
    updateSelectedMetrics(selectedMetrics),
    updateSelectedBaselineChartDataPoint(null),
  ];

  if (selectedMetrics.length) {
    changeMetricsSelectionActions.push(operations.fetchMetricsHistory(options));
  }

  return Promise.all(changeMetricsSelectionActions.map((action) => dispatch(action)));
};

export const initialize = createApiAction(
  types.INITIALIZE,
  async ({ jobId, orderIndex }, meta, dispatch, getState) => {
    const { auth } = moduleSelectors.routerQuerySelector(getState());
    await dispatch(actions.fetchJobData({ auth, jobId }));
    dispatch(trackEvent(PERFORMANCE_EVENTS.HISTORY_OPEN));
    return dispatch(operations.changeTestPage({ orderIndex }));
  },
);

export const onRouteParamsChange = ({
  jobId, orderIndex, shouldCallInit,
}) => (dispatch) => {
  if (shouldCallInit) {
    return dispatch(operations.initialize({ jobId, orderIndex }));
  }
  return dispatch(operations.changeTestPage({ orderIndex }));
};

export const selectBaselineDataPoint = (dataPayload) => (dispatch, getState) => Promise.all([
  dispatch(actions.updateSelectedBaselineChartDataPoint(dataPayload)),
  dataPayload ? dispatch(actions.fetchSelectedBaselineJobData({
    ...dataPayload,
    ...selectors.fetchJobDataSelector(getState()),
  })) : null,
]);
